import { scan } from "react-scan"; // must be imported before React and React DOM
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { Provider } from "react-redux";
import "./main.css";

import { persistor, store } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "./page/ErrorBoundary";
import { routes } from "./v2/navigation";
import { SidebarProvider } from "./components/ui/sidebar";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, _) => failureCount < 1,
        },
    },
});

scan({
    enabled: true,
});

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <SidebarProvider className="max-w-screen">
                            {/* <ReactQueryDevtools initialIsOpen={true} /> */}
                            <RouterProvider router={routes} />
                        </SidebarProvider>
                    </PersistGate>
                </Provider>
            </QueryClientProvider>
        </ErrorBoundary>
    </StrictMode>,
);
